// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DraggableItem.draggable div {\n  cursor: grab !important;\n}\n.DraggableItem.draggable.dragging div {\n  cursor: grabbing !important;\n}\n.DraggableArea {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n.DraggableArea .Overlay {\n  position: fixed;\n  z-index: 999;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: rgba(0,0,0,0.1);\n}\n", ""]);
// Exports
module.exports = exports;
